export default {
    root: {
        class: [
            // Misc
            'overflow-x-auto',
        ],
    },
    list: {
        class: [
            // Flex & Alignment
            'flex items-center flex-nowrap',

            // Spacing
            'm-0 p-0 list-none leading-none',
        ],
    },
    itemLink: {
        class: [
            // Flex & Alignment
            'flex items-center',

            // Shape
            'rounded-md',

            // Color
            'text-gray-700 dark:text-white/70',

            // States
            'focus-visible:outline-none focus-visible:outline-offset-0',
            'focus-visible:ring-1 focus-visible:ring-black dark:focus-visible:ring-primary-400',

            // Transitions
            'transition-shadow duration-200',

            // Misc
            'text-decoration-none text-sm',
        ],
    },
    itemIcon: {
        class: 'text-gray-700 dark:text-white/70',
    },
    separator: {
        class: [
            // Flex & Alignment
            'flex items-center',

            // Spacing
            'mx-2',

            // Color
            'text-gray-700',
        ],
    },
};
